<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10LLx0R/tc-custom/9780830894260.jpg?1696025100716" alt="This image is the cover for the book Slow Church Study Guide"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Slow Church Study Guide
      </h1>
      <p class="bookDescription body article font2">
        <p>High-speed internet. Rapid rewards. Quick thinking. Fast food. Fast . . . church? <em>Slow Church</em> by Chris Smith and John Pattison has been eagerly received by a people who are ready to be invited out of franchise faith and back into the kingdom of God. This eleven-session study guide provides an opportunity to reflect on the message of this groundbreaking book both individually and in community. Each session features</p>  A guide to <em>lectio divina</em>  Suggested videos that can be watched online A series of in-depth questions expanded from what is currently in the book A quote for reflection  <p>Here is an opportunity to begin to develop a deeper and richer community where people know each other well and love one another as Christ loved the church.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        C. Christopher Smith, John Pattison
      </h2>
      
      <p class="authorDescription body article"><p>C. Christopher Smith is editor of <em>The Englewood Review of Books</em>, and a member of the Englewood Christian Church community on the urban Near Eastside of Indianapolis.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4b12e307